import React, { Component } from "react";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import QueryBuilder from "./QueryBuilder";

export class CustomSQLQuery extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const element = document.getElementById('restRoutesQueryEditor');

    if (typeof CodeMirror === 'undefined') {
      return;
    }

    var restRoutesSQLEditor = CodeMirror.fromTextArea(element, {
      mode: 'text/x-sql',
      indentWithTabs: true,
      smartIndent: true,
      lineNumbers: true,
      matchBrackets : true,
      autofocus: true,
      extraKeys: {"Ctrl-Space": "autocomplete"},
      hintOptions: {tables: {
          users: ["name", "score", "birthDate"],
          countries: ["name", "population", "size"]
        }}
    });

    function updateTextArea() {
      restRoutesSQLEditor.save();
      const currentValue = element.value;
      element.value = '';
      var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value").set;
      nativeInputValueSetter.call(element, currentValue);

      var ev2 = new Event('input', { bubbles: true});
      element.dispatchEvent(ev2);
    }
    restRoutesSQLEditor.on('change', updateTextArea);
  }

  render() {
    return(
      <div id="poststuff" className="display-data-box">
        <div id="slugdiv" className="postbox">
          <h2 className="hndle ui-sortable-handle"><span>Custom SQL Query</span></h2>
          <div className="inside" style={{display: 'block'}}>

            <div className="notice notice-warning inline" style={{display: 'block'}}><p><strong>This is a dangerous endpoint type!</strong> You must be sure of what you are doing. This endpoint will let you update both single and a range of entries from any kind of database table, even default WordPress ones. So, pay attention to the query you are writing, you may turn your site completely unusable when using wrong queries.</p></div>

            <p>This a very advanced endpoint type. It should be used by developers in order to write custom SQL queries that
              will be executed by the endpoint. If you write a custom SELECT query, the results of the query will be returned.
              <strong> If you don't know what you are doing, please choose another endpoint type.</strong></p>

            <p>You can use placeholders for replacing URL parameters into your custom SQL query. For this, you must wrap it with %, like ID = %post_id% - where post_id is your custom URL parameter for the endpoint.</p>

            {this.props.endpoint.customSQLQuery && this.props.endpoint.customSQLQuery.map(
              (el, index) =>

                <FieldGroupContext.Provider key={index} value={{
                  action: 'customSQLQuery',
                  currentItem: index,
                  endpointId: this.props.id,
                  endpoint: this.props.endpoint
                }}>

                  <QueryBuilder group={'queryBuilder'} key={index + '-queryBuilder'}/>

                </FieldGroupContext.Provider>
            )}

          </div>
        </div>
      </div>
    )
  }
}
